import { render, staticRenderFns } from "./OrganizationsProjectsWidget.vue?vue&type=template&id=2f5e3c18&scoped=true"
import script from "./OrganizationsProjectsWidget.vue?vue&type=script&lang=js"
export * from "./OrganizationsProjectsWidget.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsProjectsWidget.vue?vue&type=style&index=0&id=2f5e3c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5e3c18",
  null
  
)

export default component.exports